import { SyntheticEvent, useRef } from 'react';
import { DeleteSquareXButton, UploadIcon } from '../../../assets/images/components/NudosComponents';
import Loading from '../Loading';
import './NudosFileInput.scss';

const NudosFileInput = ({
  uploadedFileHandler,
  buttonText,
  label,
  isFilled,
  errorText,
  isDisabled,
  errorStyles,
  color,
  resetSelectionWhenClickingWhenFilled,
  isLoading,
  fakeLabel,
  customWidth,
  customHeight,
  customBg,
  specialFill
}: InudosFileInput) => {
  const hiddenFileinput = useRef<HTMLInputElement>(null);
  const errorTextStyle = errorStyles && !isFilled && !specialFill ? 'buttonErrorText' : '';
  const handleClick = (event: SyntheticEvent) => {
    event.preventDefault();
    if (isFilled && resetSelectionWhenClickingWhenFilled) {
      if (hiddenFileinput.current?.value) hiddenFileinput.current.value = '';
      return uploadedFileHandler(undefined);
    }
    if (hiddenFileinput.current !== null) hiddenFileinput.current.click();
  };
  const handleChange = (event: any) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile || isLoading) return;
    uploadedFileHandler(uploadedFile);
  };
  return (
    <section
      className={`nudosFileInput ${isDisabled ? 'disabled' : ''} ${
        (errorText && errorText.length > 0) || errorStyles ? 'error' : ''
      } ${isFilled ? `filled ${color === 'orange' ? 'orangeFilled' : ''}` : ''}`}
    >
      {label && <div className="label">{label}</div>}
      {fakeLabel && !label && <div className="fakeLabel" />}
      <div
        className="uploaderButton"
        style={{
          width: customWidth || '',
          height: customHeight ? customHeight : '',
          background: customBg || '',
          border: isFilled && specialFill ? '1px dashed #070F21' : ''
        }}
        onClick={handleClick}
      >
        {!isLoading && (
          <>
            {(isFilled || (errorText && errorText.length > 0)) && (
              <span className="iconContainer">{specialFill ? <UploadIcon /> : <DeleteSquareXButton />}</span>
            )}
            {!isFilled && !(errorText && errorText.length > 0) && (
              <span className="iconContainer">
                <UploadIcon />
              </span>
            )}
            {
              <div
                className={`buttonTextContainer ${errorTextStyle}`}
                style={{ color: isFilled && specialFill ? '#070F21' : '' }}
              >
                {buttonText}
              </div>
            }
          </>
        )}
        {isLoading && <Loading />}
      </div>
      {errorText && <div className="errorText">{errorText}</div>}
      {!isDisabled && !isLoading && (
        <input type="file" className="hidden" ref={hiddenFileinput} onChange={handleChange} />
      )}
    </section>
  );
};

export default NudosFileInput;

export interface InudosFileInput {
  uploadedFileHandler: (uploadedFile?: File) => void;
  buttonText: string | JSX.Element;
  label?: string;
  isFilled?: boolean;
  errorText?: string;
  isDisabled?: boolean;
  errorStyles?: boolean;
  color?: string;
  resetSelectionWhenClickingWhenFilled?: boolean;
  isLoading?: boolean;
  fakeLabel?: boolean;
  customWidth?: string;
  customHeight?: string;
  customBg?: string;
  specialFill?: boolean;
}
